import { takeLatest } from 'redux-saga/effects';
import {
  getFarmAnimalListSuccess, getFarmAnimalListFail,
  getFarmAnimalDetailsSuccess, getFarmAnimalDetailsFail,
  getAnimalLineageDetailsSuccess, getAnimalLineageDetailsFail,
  getAnimalInventoryListSuccess, getAnimalInventoryListFail,
  getAnimalInventoryDetailsSuccess, getAnimalInventoryDetailsFail,
  doUploadAnimalPhotoSuccess, doUploadAnimalPhotoFail,
  getAnimalPhotoListSuccess, getAnimalPhotoListFail,
  doInventoryTransferUpdateSuccess, doInventoryTransferUpdateFail,
  getAnimalTransferListSuccess, getAnimalTransferListFail,
  
} from './farmAnimalState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/console/farm-animals');
const redirectData = {route:'/console/registered-animals', mode: 'list', recordId:0 };
const lineageService = createCrudService('api/v1/console/farm-animal/lineage');
const photoService = createCrudService('api/v1/console/farm-animal');
const tranferService = createCrudService('api/v1/console/animal-transfers');
const modelName = 'Farm Animals';
const modelId = 'id';
const inventoryRedirectData = {route:'/console/animal-inventory', mode: 'list', recordId:0 };

function* getFarmAnimalList(data) {	
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getFarmAnimalListSuccess, 
		getFarmAnimalListFail,
		null, null, LOADING_MSG);
}

function* getFarmAnimalDetails(data) {
	const { recordId, ...rest } = data.payload;
	yield doCrudCall(
		() => crudService.getDetails(recordId, null, rest), 
		getFarmAnimalDetailsSuccess, 
		getFarmAnimalDetailsFail,
		null, null, LOADING_MSG);		
}

function* doFarmAnimalCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getFarmAnimalDetailsSuccess, 
		getFarmAnimalDetailsFail,
		createRecordSuccess(modelName),
		redirectData,
		SAVING_MSG);
}

function* doFarmAnimalUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getFarmAnimalDetailsSuccess, 
		getFarmAnimalDetailsFail,
		updateRecordSuccess(modelName),
		redirectData,
		UPDATING_MSG);	
}

function* doFarmAnimalDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getFarmAnimalDetailsSuccess, 
		getFarmAnimalDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* getAnimalLineageDetails(data){
	yield doCrudCall(
		() => lineageService.getDetails(data.payload), 
		getAnimalLineageDetailsSuccess, 
		getAnimalLineageDetailsFail);	
}

function* getAnimalInventoryList(data) {	
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getAnimalInventoryListSuccess, 
		getAnimalInventoryListFail,
		null, null, LOADING_MSG);
}

function* getAnimalInventoryDetails(data) {
	const { recordId, ...rest } = data.payload;
	yield doCrudCall(
		() => crudService.getDetails(recordId, null, rest), 
		getAnimalInventoryDetailsSuccess, 
		getAnimalInventoryDetailsFail,
		null, null, LOADING_MSG);		
}

function* doAnimalInventoryCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getAnimalInventoryDetailsSuccess, 
		getAnimalInventoryDetailsFail,
		createRecordSuccess(modelName),
		inventoryRedirectData,
		SAVING_MSG);
}

function* doAnimalInventoryUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getAnimalInventoryDetailsSuccess, 
		getAnimalInventoryDetailsFail,
		updateRecordSuccess(modelName),
		inventoryRedirectData,
		UPDATING_MSG);	
}

function* doAnimalInventoryDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getAnimalInventoryDetailsSuccess, 
		getAnimalInventoryDetailsFail,
		deleteRecordSuccess(modelName),
		{...inventoryRedirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* doUploadAnimalPhoto(data){
	const { recordId, file } = data.payload;
	yield doCrudCall(
		() => photoService.doImport(`${recordId}/upload/photos`, file), 
		doUploadAnimalPhotoSuccess, 
		doUploadAnimalPhotoFail,
		'Upload of animal photo completed',
		{...inventoryRedirectData, mode: 'reload'},
		'Uploading photo/s');	
}

function* getAnimalPhotoList(data) {	
	const { recordId } = data.payload;
	yield doCrudCall(
		() => photoService.doGetRequest(`${recordId}/photos`, data.payload), 
		getAnimalPhotoListSuccess, 
		getAnimalPhotoListFail,
		null, null, LOADING_MSG);
}

function* doInventoryTransferUpdate(data){
	yield doCrudCall(
		() => tranferService.doCreate(data.payload), 
		doInventoryTransferUpdateSuccess, 
		doInventoryTransferUpdateFail,
		'Animal transfer to another account was complete',
		{...inventoryRedirectData, mode: 'reload'},
		UPDATING_MSG);	
}

function* getAnimalTransferList(data){
	yield doCrudCall(
		() => tranferService.getList(data.payload), 
		getAnimalTransferListSuccess, 
		getAnimalTransferListFail,
		null,
		null,
		UPDATING_MSG);	
}

function* farmAnimalSaga() {
  yield takeLatest('farmAnimal/getFarmAnimalList', getFarmAnimalList);
  yield takeLatest('farmAnimal/getFarmAnimalDetails', getFarmAnimalDetails);
  yield takeLatest('farmAnimal/doFarmAnimalCreate', doFarmAnimalCreate);
  yield takeLatest('farmAnimal/doFarmAnimalUpdate', doFarmAnimalUpdate);
  yield takeLatest('farmAnimal/doFarmAnimalDelete', doFarmAnimalDelete);  
  yield takeLatest('farmAnimal/getAnimalLineageDetails', getAnimalLineageDetails); 
  yield takeLatest('farmAnimal/getAnimalInventoryList', getAnimalInventoryList);
  yield takeLatest('farmAnimal/getAnimalInventoryDetails', getAnimalInventoryDetails);
  yield takeLatest('farmAnimal/doAnimalInventoryCreate', doAnimalInventoryCreate);
  yield takeLatest('farmAnimal/doAnimalInventoryUpdate', doAnimalInventoryUpdate);
  yield takeLatest('farmAnimal/doAnimalInventoryDelete', doAnimalInventoryDelete); 
  yield takeLatest('farmAnimal/doUploadAnimalPhoto', doUploadAnimalPhoto); 
  yield takeLatest('farmAnimal/getAnimalPhotoList', getAnimalPhotoList);
  yield takeLatest('farmAnimal/doInventoryTransferUpdate', doInventoryTransferUpdate);
  yield takeLatest('farmAnimal/getAnimalTransferList', getAnimalTransferList);
}

export default farmAnimalSaga;
